import { IdentifierDTO } from '@zazume/zzm-base';

import { doGet, doPost } from '../../helpers';

export interface VoPConsentStatus {
  connected: boolean;
  status?: 'pending' | 'active' | 'expired' | 'error';
  provider?: string;
  refreshTokenExpiresAt?: string;
}

export interface VoPValidationResult {
  resultCode: 'matched' | 'close_match' | 'not_matched' | 'cannot_be_checked' | 'temporarily_unavailable';
  reason?: {
    type: string;
    code: string;
  };
  suggestedName?: { first_name: string; last_name: string } | string;
}

export const vop = {
  getConsentURL: () => doGet<{ url: string }>('/dashboard/vop/consent'),
  getConsentStatus: () => doGet<VoPConsentStatus>('/dashboard/vop/consent/status'),
  renewConsent: () => doGet<{ url: string }>('/dashboard/vop/consent/renew'),
  validateOwnerAccount: (ownerAccountId: IdentifierDTO) =>
    doPost<VoPValidationResult>(`/dashboard/vop/validate/${ownerAccountId}`)
};
